<template>
  <div>
    <!-- Inner Header -->
    <section class="section-padding bg-dark py-5 inner-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h1 class="mt-0 mb-3 text-white">Contact Us</h1>
            <div class="breadcrumbs">
              <p class="mb-0 text-white"><a class="text-white" href="#">Home</a> / <span class="text-success">Contact Us</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Inner Header -->

    <!-- Contact Us -->

    <!-- End Contact Us -->
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    components: {},
  };
</script>

<style scoped>
  input[type='email'],
  input[type='text'],
  input[type='tel'],
  input[type='password'] {
    padding: var(--input-padding);
  }
  .icon-lg {
    font-size: 27px;
    margin-left: 3px;
  }
</style>
